let names: Readonly<Record<string, string>> = {};

/** App sets the names from /me/can before the state change that renders the pages again. */
export function setMemberNames(found: Readonly<Record<string, string>> | undefined) {
  names = Object.fromEntries(Object.entries(found ?? {}).map(([email, name]) => [email.toLowerCase(), name]));
}

/** The member name of an email, or null. */
export const knownName = (email: string | null | undefined): string | null =>
  (email && names[email.trim().toLowerCase()]) || null;

/** The member name of an email, else the part of the email before "@" and "+" (SO-1950). */
export function memberName(email: string | null | undefined): string {
  if (!email) return "";
  return knownName(email) ?? email.split("@")[0].split("+")[0];
}
